import moment from 'moment'
import { TcwAPIDate, TcwFormDate } from '@/tcw/domain/types'
import { dateOf } from './TcwService'

export const equalsDate = function(date1: TcwFormDate, date2: TcwFormDate): boolean {
  if (!(date1 instanceof Date) || !(date2 instanceof Date)) {
    return false
  }
  const [year1, month1, day1] = [date1.getFullYear(), date1.getMonth(), date1.getDate()]
  const [year2, month2, day2] = [date2.getFullYear(), date2.getMonth(), date2.getDate()]
  return year1 === year2 && month1 === month2 && day1 === day2
}

export const isSameMonth = (date1: Date, date2: Date): boolean => {
  const [year1, month1] = [date1.getFullYear(), date1.getMonth()]
  const [year2, month2] = [date2.getFullYear(), date2.getMonth()]
  return year1 === year2 && month1 === month2
}

export const addDate = (date: Date, addVal: number, addType: 'y' | 'M' | 'd' = 'd'): Date => {
  const m = moment(date)
  m.add(addType, addVal)
  return m.toDate()
}

export const isBefore = (date1: Date | string, date2: Date | string): boolean => {
  const [m1, m2] = [moment(date1), moment(date2)]
  return m1.isBefore(m2)
}

export const isAfter = (date1: Date | string, date2: Date | string): boolean => {
  const [m1, m2] = [moment(date1), moment(date2)]
  return m1.isAfter(m2)
}

export const toDate = (dateStr: string, format: string): Date => {
  const m = moment(dateStr, format)
  return m.toDate()
}

export const convertDateToStr = (date: TcwFormDate, format: string): string => {
  if (!date) {
    return ''
  }
  return moment(date).format(format)
}

export const convertStrToDate = (dateStr: TcwAPIDate): TcwFormDate => {
  if (!dateStr) {
    return null
  }
  return dateOf(dateStr)
}

export const convertDateStrToStr = (dateStr: string, format: string): string | null => {
  if (!dateStr) {
    return null
  }
  const date = dateOf(dateStr)
  if (date === null) {
    return null
  }
  return convertDateToStr(date, format)
}

export const outputHun = (
  jikan: string | number | null | undefined,
  zeroIsEmpty = true
): string => {
  if (jikan === null || jikan === undefined) {
    return ''
  }

  const num = Number(jikan)
  if (isNaN(num)) {
    return ''
  }

  if (zeroIsEmpty && num === 0) {
    return ''
  }

  const ji = (num / 60) | 0
  const hun = num % 60
  const jiStr = ji < 100 ? `0${ji}`.slice(-2) : ji
  return jiStr + ':' + `0${hun}`.slice(-2)
}

export const getDefaultTime = (date: Date): Date => {
  return new Date(date.getFullYear(), date.getMonth() + 1, date.getDate())
}

export const now = (): Date => {
  const now = new Date()
  // 深夜5時までを今日と判定する（TODO 要確認）
  const hour = now.getHours()
  if (hour < 5) {
    now.setDate(now.getDate() - 1)
  }

  return now
}
